import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleDuplicateSetModal } from '../../../../../slices/modals/reducer';
import VersionDetails from '../VersionDetails';
import { resetDuplicateErr, resetVersionDetails, setVersionDetails } from '../../../../../slices/campaigns/reducer';
import { duplicateVersion } from '../../../../../slices/campaigns/thunk';
import ErrorAlert from '../../../../../Components/Common/ErrorAlert';

function DuplicateSetModal() {
  const dispatch = useDispatch();
  // Select Modal State
  const selectState = createSelector(state => state, state => ({
    duplicateModalState: state.Modal.duplicateSetModal,
    versionDetailState: state.Campaign.versionDetails,
    duplicateErr: state.Campaign.duplicateErr,
    duplicateErrMsg: state.Campaign.duplicateErrMsg
  }))
  const { duplicateModalState, versionDetailState, duplicateErr, duplicateErrMsg } = useSelector(selectState);

  const [isSubmit, setIsSubmit] = useState(false);
  const [isReset, setIsReset] = useState(false);

  function handleSubmit() {
    setIsSubmit(true);
  }

  function handleClose() {
    dispatch(toggleDuplicateSetModal());
    setIsReset(true);
    setTimeout(() => {
      dispatch(resetVersionDetails());
    }, 300);
  }

  async function submitFunc(values) {
    await dispatch(duplicateVersion(values));
    dispatch(toggleDuplicateSetModal());
    setIsSubmit(false);
  }

  return (
    <Modal isOpen={duplicateModalState} toggle={handleClose} centered size='md'>
      <ModalHeader className='p-3' toggle={handleClose}>
        <b>Duplicate</b>
        <span className='ms-2 fw-normal'>{(versionDetailState.name || "")}</span>
      </ModalHeader>
      <ModalBody className='px-3'>
        <ErrorAlert errorState={duplicateErr} errorMessage={duplicateErrMsg} resetError={resetDuplicateErr} />
        <VersionDetails hiddenSizes={true} isSubmit={isSubmit} isReset={isReset} submitFunc={async (values) => await submitFunc(values)} />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' type='button' onClick={handleClose}>Close</button>
        <button className='btn btn-info' type='submit' onClick={handleSubmit} disabled={duplicateErr ? true : false}>
          Duplicate
          {duplicateErr ? <Spinner size='sm' className='ms-2'>Loading...</Spinner> : null}
          </button>
      </ModalFooter>
    </Modal>
  )
}

export default DuplicateSetModal
